import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { db } from './firebase';
import { collection, query, where, getDocs, updateDoc, doc } from 'firebase/firestore';

export default function MyTrialBag() {
  const navigate = useNavigate();
  const TEST_UNLOCK = true;

  const [bookingData, setBookingData] = useState(null);
  const [zoomImage, setZoomImage] = useState(null);
  const [showBill, setShowBill] = useState(false);
  const [showOfferPopup, setShowOfferPopup] = useState(false);
  const [offerPopupSeen, setOfferPopupSeen] = useState(false);
  const [decisions, setDecisions] = useState(() => {
    try {
      const saved = localStorage.getItem('fivetryTrialDecisions');
      return saved ? JSON.parse(saved) : {};
    } catch (e) {
      return {};
    }
  });

  // Tick every minute so the unlock time auto-flips without refresh
  const [, forceTick] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => forceTick(t => t + 1), 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    try {
      const data = localStorage.getItem('fivetryActiveBookingData');
      if (data) setBookingData(JSON.parse(data));
    } catch (e) {
      console.error('Error loading booking data:', e);
    }
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem('fivetryTrialDecisions', JSON.stringify(decisions));
    } catch (e) {}
  }, [decisions]);

  const parsePrice = (priceStr) => {
    return parseFloat(String(priceStr).replace(/[₹,]/g, '')) || 0;
  };

  const total = bookingData?.selectedItems?.reduce((sum, item, i) => {
    if (decisions[i] === 'buy') return sum + parsePrice(item.price);
    return sum;
  }, 0) || 0;
  const buyCount = Object.values(decisions).filter(d => d === 'buy').length;
  const returnCount = (bookingData?.selectedItems?.length || 0) - buyCount;

  const discountRate = buyCount >= 3 ? 0.2 : buyCount === 2 ? 0.1 : buyCount === 1 ? 0.05 : 0;
  const discountPct = Math.round(discountRate * 100);
  const discount = Math.round(total * discountRate);
  const payableTotal = total - discount;

  // TIME-SLOT LOCK
 const slotActive = (() => {
    if (TEST_UNLOCK) return true; // ⚠️ remove after testing
    if (!bookingData || !bookingData.trialStartISO) return true; // fallback if no data
    return new Date() >= new Date(bookingData.trialStartISO);
  })();

  const unlockTimeLabel = (() => {
    if (!bookingData?.trialStartISO) return '';
    const d = new Date(bookingData.trialStartISO);
    return d.toLocaleString('en-IN', {
      weekday: 'long',
      day: 'numeric',
      month: 'short',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  })();

    const setDecision = (index, value) => {
    if (!slotActive) return;
    setDecisions({ ...decisions, [index]: value });
    if (value === 'buy' && !offerPopupSeen) {
      setShowOfferPopup(true);
      setOfferPopupSeen(true);
    }
  };

    const handlePayment = () => {
    if (!slotActive) return;
    if (total === 0) {
      alert('Please mark at least one item as BUY before paying.');
      return;
    }
    setShowBill(true);
  };

    const [showPayScreen, setShowPayScreen] = useState(false);

    const payVia = (pkg) => {
    const base = `pa=8291052256@kotakbank&pn=FIVETRY&am=${payableTotal}&cu=INR&tn=${encodeURIComponent(bookingData.bookingId)}`;
    const isAndroid = /android/i.test(navigator.userAgent);
    const url = isAndroid && pkg
      ? `intent://pay?${base}#Intent;scheme=upi;package=${pkg};end`
      : `upi://pay?${base}`;
    window.location.href = url;
  };

  const confirmAndPay = async () => {
    const purchased = bookingData.selectedItems
      .map((item, i) => (decisions[i] === 'buy' ? item : null))
      .filter(Boolean);
    try {
      const q = query(collection(db, 'bookings'), where('bookingId', '==', bookingData.bookingId));
      const snap = await getDocs(q);
      for (const d of snap.docs) {
        await updateDoc(doc(db, 'bookings', d.id), {
          purchasedItems: purchased,
          billSubtotal: total,
          billDiscount: discount,
          billTotal: payableTotal,
        });
      }
    } catch (e) {
      console.error('Error saving purchased items:', e);
    }
    setShowBill(false);
    setShowPayScreen(true);
  };

  // EMPTY STATE
  if (!bookingData) {
    return (
      <div style={{ minHeight: '100vh', background: '#fafaf7', fontFamily: 'Arial', paddingBottom: '90px' }}>
        <div style={{ padding: '18px 24px', borderBottom: '0.5px solid #eeeae3', textAlign: 'center' }}>
          <h1 onClick={() => navigate('/')} style={{
            margin: 0, fontSize: '22px', fontWeight: '500', color: '#1a1a1a',
            fontFamily: '"Playfair Display", Georgia, serif',
            letterSpacing: '6px', cursor: 'pointer',
          }}>FIVETRY</h1>
        </div>
        <div style={{ padding: '80px 24px', textAlign: 'center' }}>
          <div style={{ fontSize: '13px', letterSpacing: '5px', color: '#9c7d4f', marginBottom: '14px', fontWeight: '600', textTransform: 'uppercase' }}>No active trial</div>
          <h2 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '28px', color: '#1a1a1a', margin: 0, marginBottom: '12px' }}>Trial Bag Empty</h2>
          <p style={{ color: '#666', maxWidth: '320px', margin: '0 auto 24px', lineHeight: '1.6' }}>
            Book a trial from the home page and your items will appear here.
          </p>
          <button onClick={() => navigate('/')} style={{
            background: '#1a1a1a', color: 'white', border: 'none',
            padding: '14px 32px', borderRadius: '10px', fontSize: '13px',
            letterSpacing: '2px', fontWeight: '600', cursor: 'pointer',
          }}>SHOP NOW</button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf7', fontFamily: 'Arial', paddingBottom: '180px' }}>

      {/* NAVBAR */}
      <div style={{ padding: '18px 24px', borderBottom: '0.5px solid #eeeae3', textAlign: 'center', background: '#fafaf7' }}>
        <h1 onClick={() => navigate('/')} style={{
          margin: 0, fontSize: '22px', fontWeight: '500', color: '#1a1a1a',
          fontFamily: '"Playfair Display", Georgia, serif',
          letterSpacing: '6px', cursor: 'pointer',
        }}>FIVETRY</h1>
      </div>

      {/* HEADER BAND */}
      <div style={{ background: '#1a1a1a', color: 'white', padding: '24px 20px' }}>
        <div style={{ fontSize: '11px', letterSpacing: '3px', color: '#b89968', fontWeight: '700', marginBottom: '8px' }}>YOUR ACTIVE TRIAL</div>
        <h2 style={{
          fontFamily: '"neto serif',
          fontSize: '24px', fontWeight: '500', margin: 0, marginBottom: '12px', color: 'white',
        }}>My Trial Bag</h2>
        <div style={{ fontSize: '13px', color: '#a8a092', lineHeight: '1.6' }}>
          <div><span style={{ color: '#b89968' }}>Booking · </span><span style={{ color: 'white', fontWeight: '600' }}>{bookingData.bookingId}</span></div>
          <div><span style={{ color: '#b89968' }}>Delivery · </span><span style={{ color: 'white', fontWeight: '600' }}>{bookingData.deliveryDay}</span></div>
          <div><span style={{ color: '#b89968' }}>Slot · </span><span style={{ color: 'white', fontWeight: '600' }}>{bookingData.timeSlot}</span></div>
        </div>
      </div>

      {/* LOCK BANNER (when slot hasn't started) */}
      {!slotActive && (
        <div style={{
          background: '#fff8ec',
          border: '1px solid #f5d99a',
          borderRadius: '14px',
          padding: '18px 20px',
          margin: '20px',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '32px', marginBottom: '8px' }}>🔒</div>
          <div style={{ fontSize: '11px', letterSpacing: '2px', color: '#9c7d4f', fontWeight: '700', marginBottom: '6px' }}>
            TRIAL UNLOCKS AT
          </div>
          <div style={{
            fontFamily: '"neto serif',
            fontSize: '18px', color: '#1a1a1a', fontWeight: '600', marginBottom: '10px',
          }}>
            {unlockTimeLabel}
          </div>
          <p style={{ fontSize: '13px', color: '#666', margin: 0, lineHeight: '1.5' }}>
            BUY and RETURN options will activate once your items arrive at your door.
          </p>
        </div>
      )}

      {/* INSTRUCTION */}
      {slotActive && (
        <div style={{ padding: '24px 20px 8px', textAlign: 'center' }}>
          <div style={{ fontSize: '11px', letterSpacing: '3px', color: '#9c7d4f', fontWeight: '700', marginBottom: '8px' }}>MARK YOUR CHOICES</div>
          <p style={{ fontSize: '13px', color: '#666', margin: 0, lineHeight: '1.5', maxWidth: '320px', marginLeft: 'auto', marginRight: 'auto' }}>
            Tap <strong style={{ color: '#16a34a' }}>BUY</strong> on items you love. Tap <strong style={{ color: '#1a1a1a' }}>RETURN</strong> on ones that don't work.
          </p>
        </div>
      )}

      {/* OFFER NUDGE */}
      {slotActive && (
        <div style={{ margin: '4px 20px 0' }}>
          <div style={{
            background: buyCount >= 3 ? '#eaf7ee' : '#fff8ec',
            border: buyCount >= 3 ? '1px solid #a8e0bd' : '1px solid #f5d99a',
            borderRadius: '12px', padding: '12px 16px', textAlign: 'center',
            fontSize: '13px', fontWeight: '700',
            color: buyCount >= 3 ? '#16a34a' : '#9c7d4f',
          }}>
            {buyCount === 0
              ? '✨ Buy 1 → 5% · Buy 2 → 10% · Buy 3+ → 20% off!'
              : buyCount === 1
                ? '5% OFF applied! Buy 1 more → 10% off 🎉'
                : buyCount === 2
                  ? '10% OFF applied! Buy 1 more → 20% off 🎉'
                  : '🎉 20% OFF unlocked — maximum savings!'}
          </div>
        </div>
      )}

      {/* ITEMS LIST */}
      <div style={{ padding: '16px 20px' }}>
        {bookingData.selectedItems.map((item, index) => {
          const decision = decisions[index];
          const isBuy = decision === 'buy';
          const isReturn = decision === 'return';

          return (
            <div key={index} style={{
              background: 'white',
              borderRadius: '14px',
              padding: '14px',
              marginBottom: '14px',
              display: 'flex',
              gap: '14px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              border: isBuy ? '2px solid #16a34a' : isReturn ? '2px solid #1a1a1a' : '1px solid #eeeae3',
              transition: 'all 0.2s',
              opacity: slotActive ? 1 : 0.55,
            }}>
              <img src={item.image} alt={item.name} onClick={() => setZoomImage(item.image)} style={{
                width: '130px', height: '175px', objectFit: 'cover', borderRadius: '10px', flexShrink: 0, cursor: 'zoom-in',
              }} />

              <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <h4 style={{ margin: 0, marginBottom: '5px', fontSize: '13px', color: '#1a1a1a', lineHeight: '1.3' }}>{item.name}</h4>
                <p style={{ margin: 0, marginBottom: '3px', fontSize: '12px', color: '#888' }}>
                  Size: <span style={{ fontWeight: '700', color: '#1a1a1a' }}>{item.size}</span>
                </p>
                <p style={{ margin: 0, marginBottom: '10px', fontSize: '14px', fontWeight: '700', color: '#1a1a1a' }}>{item.price}</p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', marginTop: 'auto' }}>
                  <button
                    onClick={() => setDecision(index, 'buy')}
                    disabled={!slotActive}
                    style={{
                      width: '100%',
                      background: isBuy ? '#16a34a' : 'white',
                      color: isBuy ? 'white' : '#16a34a',
                      border: '1.5px solid #16a34a',
                      padding: '9px',
                      borderRadius: '999px',
                      fontSize: '12px',
                      fontWeight: '700',
                      cursor: slotActive ? 'pointer' : 'not-allowed',
                      letterSpacing: '1px',
                    }}
                  >
                    {isBuy ? '✓ BUY' : 'BUY'}
                  </button>
                  <button
                    onClick={() => setDecision(index, 'return')}
                    disabled={!slotActive}
                    style={{
                      width: '100%',
                      background: isReturn ? '#1a1a1a' : 'white',
                      color: isReturn ? 'white' : '#1a1a1a',
                      border: '1.5px solid #1a1a1a',
                      padding: '9px',
                      borderRadius: '999px',
                      fontSize: '12px',
                      fontWeight: '700',
                      cursor: slotActive ? 'pointer' : 'not-allowed',
                      letterSpacing: '1px',
                    }}
                  >
                    {isReturn ? '✓ RETURN' : 'RETURN'}
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* STICKY PAYMENT BAR */}
      <div style={{
        position: 'fixed',
        bottom: '70px',
        left: 0,
        right: 0,
        background: 'white',
        borderTop: '1px solid #eeeae3',
        padding: '14px 20px',
        boxShadow: '0 -4px 12px rgba(0,0,0,0.06)',
        zIndex: 1400,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '10px' }}>
          <div style={{ fontSize: '12px', color: '#666' }}>
            <span style={{ color: '#16a34a', fontWeight: '700' }}>{buyCount} BUY</span>
            <span> · </span>
            <span style={{ color: '#1a1a1a', fontWeight: '700' }}>{returnCount} RETURN</span>
          </div>
          <div style={{ textAlign: 'right' }}>
            {discountPct > 0 && (
              <div style={{ fontSize: '12px', color: '#16a34a', fontWeight: '700' }}>{discountPct}% OFF applied 🎉</div>
            )}
            <div style={{
              fontFamily: '"neto serif',
              fontSize: '22px', color: '#1a1a1a', fontWeight: '600',
            }}>
              ₹{payableTotal.toLocaleString('en-IN')}
            </div>
          </div>
        </div>

        <button
          onClick={handlePayment}
          disabled={!slotActive || total === 0}
          style={{
            width: '100%',
            background: (slotActive && total > 0) ? '#16a34a' : '#999',
            color: 'white',
            border: 'none',
            padding: '14px',
            borderRadius: '12px',
            fontSize: '13px',
            letterSpacing: '2px',
            fontWeight: '700',
            cursor: (slotActive && total > 0) ? 'pointer' : 'not-allowed',
            transition: 'all 0.2s',
          }}
        >
          {slotActive ? 'MAKE PAYMENT' : '🔒 UNLOCKS AT TRIAL'}
        </button>
      </div>

      {/* OFFER POPUP (first BUY) */}
      {showOfferPopup && (
        <div
          onClick={() => setShowOfferPopup(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            zIndex: 3200, display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '20px', boxSizing: 'border-box',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'white', borderRadius: '16px', width: '100%', maxWidth: '340px',
              padding: '26px 24px', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            }}
          >
            <div style={{ fontSize: '34px', marginBottom: '8px' }}>🎁</div>
            <div style={{ fontSize: '11px', letterSpacing: '2px', color: '#9c7d4f', fontWeight: '700', marginBottom: '6px' }}>THE MORE YOU KEEP, THE MORE YOU SAVE</div>
            <h2 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '22px', color: '#1a1a1a', margin: '0 0 16px' }}>Unlock bigger discounts</h2>

            <div style={{ textAlign: 'left', marginBottom: '18px' }}>
              {[
                { n: 'Buy 1 item', d: '5% OFF', on: buyCount >= 1 },
                { n: 'Buy 2 items', d: '10% OFF', on: buyCount >= 2 },
                { n: 'Buy 3+ items', d: '20% OFF', on: buyCount >= 3 },
              ].map((t, i) => (
                <div key={i} style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '11px 14px', marginBottom: '8px', borderRadius: '10px',
                  background: t.on ? '#eaf7ee' : '#faf7f1',
                  border: t.on ? '1px solid #a8e0bd' : '1px solid #eeeae3',
                }}>
                  <span style={{ fontSize: '14px', color: '#1a1a1a', fontWeight: '600' }}>{t.n}</span>
                  <span style={{ fontSize: '14px', fontWeight: '700', color: t.on ? '#16a34a' : '#9c7d4f' }}>{t.on ? '✓ ' : ''}{t.d}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => setShowOfferPopup(false)}
              style={{
                width: '100%', background: '#1a1a1a', color: 'white', border: 'none',
                padding: '14px', borderRadius: '12px', fontSize: '13px', letterSpacing: '2px',
                fontWeight: '700', cursor: 'pointer',
              }}
            >
              GOT IT
            </button>
          </div>
        </div>
      )}

      {/* AUTO-GENERATED BILL */}
      {showBill && (
        <div
          onClick={() => setShowBill(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '20px', boxSizing: 'border-box',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'white', borderRadius: '16px', width: '100%', maxWidth: '380px',
              maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
            }}
          >
            <div style={{ background: '#1a1a1a', color: 'white', padding: '22px 24px', textAlign: 'center' }}>
              <h2 style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: '24px', letterSpacing: '5px', margin: 0, color: 'white' }}>FIVETRY</h2>
              <div style={{ fontSize: '10px', letterSpacing: '2px', color: '#b89968', marginTop: '6px', fontWeight: '600' }}>PAYMENT RECEIPT</div>
            </div>

            <div style={{ padding: '20px 24px' }}>
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Booking · <span style={{ color: '#1a1a1a', fontWeight: '700' }}>{bookingData.bookingId}</span></div>
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
                {new Date().toLocaleString('en-IN', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })}
              </div>

              <div style={{ borderTop: '1px dashed #ddd', borderBottom: '1px dashed #ddd', padding: '12px 0', marginBottom: '14px' }}>
                {bookingData.selectedItems.map((item, i) => (
                  decisions[i] === 'buy' ? (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px', fontSize: '13px' }}>
                      <div style={{ flex: 1, paddingRight: '10px' }}>
                        <div style={{ color: '#1a1a1a', fontWeight: '600' }}>{item.name}</div>
                        <div style={{ color: '#888', fontSize: '11px' }}>Size: {item.size}</div>
                      </div>
                      <div style={{ color: '#1a1a1a', fontWeight: '600', whiteSpace: 'nowrap' }}>{item.price}</div>
                    </div>
                  ) : null
                ))}
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#666', marginBottom: '8px' }}>
                <span>Subtotal</span>
                <span>₹{total.toLocaleString('en-IN')}</span>
              </div>
              {discountPct > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', color: '#16a34a', marginBottom: '8px', fontWeight: '600' }}>
                  <span>Discount ({discountPct}% off · {buyCount} item{buyCount > 1 ? 's' : ''})</span>
                  <span>− ₹{discount.toLocaleString('en-IN')}</span>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', borderTop: '2px solid #1a1a1a', paddingTop: '12px', marginTop: '8px', marginBottom: '18px' }}>
                <span style={{ fontSize: '14px', fontWeight: '700', color: '#1a1a1a' }}>Total Payable</span>
                <span style={{ fontFamily: '"neto serif', fontSize: '24px', fontWeight: '700', color: '#1a1a1a' }}>₹{payableTotal.toLocaleString('en-IN')}</span>
              </div>

              <button
                onClick={confirmAndPay}
                style={{
                  width: '100%', background: '#16a34a', color: 'white', border: 'none',
                  padding: '15px', borderRadius: '12px', fontSize: '13px', letterSpacing: '2px',
                  fontWeight: '700', cursor: 'pointer', marginBottom: '10px',
                  fontFamily: '"neto serif',
                }}
              >
                CONFIRM & PAY ₹{payableTotal.toLocaleString('en-IN')}
              </button>

              <p style={{ fontSize: '11px', color: '#999', textAlign: 'center', margin: 0, lineHeight: '1.5' }}>
                📸 Screenshot this bill for your records.<br/>You'll pay securely via your UPI app.
              </p>

              <button
                onClick={() => setShowBill(false)}
                style={{
                  width: '100%', background: 'transparent', color: '#888', border: 'none',
                  padding: '12px', fontSize: '12px', cursor: 'pointer', marginTop: '6px',
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
     )}

      {/* CHOOSE UPI APP SHEET */}
      {showPayScreen && (
        <div onClick={() => setShowPayScreen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 3200, display: 'flex', alignItems: 'flex-end', justifyContent: 'center', boxSizing: 'border-box' }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background: 'white', borderRadius: '20px 20px 0 0', width: '100%', maxWidth: '460px', padding: '24px 22px 30px', boxShadow: '0 -10px 40px rgba(0,0,0,0.25)' }}>
            <div style={{ textAlign: 'center', fontSize: '12px', color: '#666', marginBottom: '4px' }}>Paying to FIVETRY</div>
            <div style={{ textAlign: 'center', fontFamily: '"neto serif', fontSize: '30px', fontWeight: '700', color: '#1a1a1a', marginBottom: '20px' }}>₹{payableTotal.toLocaleString('en-IN')}</div>
            <div style={{ fontSize: '11px', letterSpacing: '1px', color: '#9c7d4f', fontWeight: '700', textAlign: 'center', marginBottom: '14px' }}>CHOOSE YOUR UPI APP</div>

            {[
              { label: 'Google Pay', pkg: 'com.google.android.apps.nbu.paisa.user', logo: 'https://i.ibb.co/wNBbGsC1/gpaa.png' },
              { label: 'PhonePe', pkg: 'com.phonepe.app', logo: 'https://i.ibb.co/F4bjdRvH/p-pay.png' },
              { label: 'Paytm', pkg: 'net.one97.paytm', logo: 'https://i.ibb.co/vxcQLkZf/pt.png' },
            ].map((app) => (
              <button key={app.pkg} onClick={() => payVia(app.pkg)} style={{ width: '100%', background: 'white', color: '#1a1a1a', border: '1.5px solid #e5e0d5', padding: '14px 20px', borderRadius: '12px', fontSize: '15px', fontWeight: '600', cursor: 'pointer', marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '14px' }}>
                <img src={app.logo} alt={app.label} style={{ width: '24px', height: '24px', objectFit: 'contain', borderRadius: '5px' }} />
                Pay with {app.label}
              </button>
            ))}

            <div style={{ marginTop: '18px', paddingTop: '14px', borderTop: '1px dashed #eeeae3' }}>
              <div style={{ fontSize: '10px', letterSpacing: '1.5px', color: '#9c7d4f', fontWeight: '700', textAlign: 'center', marginBottom: '10px' }}>OR PAY MANUALLY</div>
              <div style={{ background: '#fafaf7', border: '1px solid #eeeae3', borderRadius: '10px', padding: '12px 14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '10px', color: '#888', letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: '2px' }}>FIVETRY UPI ID</div>
                  <div style={{ fontSize: '14px', color: '#1a1a1a', fontWeight: '700', wordBreak: 'break-all' }}>8291052256@kotakbank</div>
                </div>
                <button
                  onClick={() => {
                    try {
                      navigator.clipboard.writeText('8291052256@kotakbank');
                      alert('UPI ID copied!\n\nOpen any UPI app → Pay to UPI ID → paste it → enter amount ₹' + payableTotal.toLocaleString('en-IN') + '\nNote: ' + bookingData.bookingId);
                    } catch (e) {
                      alert('UPI ID: 8291052256@kotakbank\nAmount: ₹' + payableTotal.toLocaleString('en-IN') + '\nNote: ' + bookingData.bookingId);
                    }
                  }}
                  style={{ background: '#1a1a1a', color: 'white', border: 'none', padding: '9px 14px', borderRadius: '8px', fontSize: '12px', fontWeight: '700', letterSpacing: '0.5px', cursor: 'pointer', flexShrink: 0 }}
                >
                  COPY
                </button>
              </div>
            </div>

            <p style={{ fontSize: '11px', color: '#999', textAlign: 'center', margin: '14px 0 0', lineHeight: '1.5' }}>
              Your app opens with the amount already filled in — just enter your UPI PIN to pay.
            </p>

            <button onClick={() => setShowPayScreen(false)} style={{ width: '100%', background: 'transparent', color: '#888', border: 'none', padding: '12px', fontSize: '12px', cursor: 'pointer', marginTop: '6px' }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* IMAGE ZOOM VIEWER */}
      {zoomImage && (
        <div
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.94)',
            zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <TransformWrapper initialScale={1} minScale={1} maxScale={5} centerOnInit={true} doubleClick={{ mode: 'zoomIn', step: 1 }} wheel={{ step: 0.2 }}>
            <TransformComponent
              wrapperStyle={{ width: '100vw', height: '100vh' }}
              contentStyle={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              <img src={zoomImage} alt="Zoomed product" style={{ maxWidth: '92vw', maxHeight: '88vh', objectFit: 'contain', borderRadius: '10px' }} />
            </TransformComponent>
          </TransformWrapper>

          <button
            onClick={() => setZoomImage(null)}
            style={{
              position: 'fixed', top: '20px', right: '20px',
              width: '46px', height: '46px', borderRadius: '50%',
              background: 'rgba(255,255,255,0.18)', color: 'white', border: 'none',
              fontSize: '26px', cursor: 'pointer', lineHeight: '1', zIndex: 10000,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ×
          </button>

          <div style={{
            position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
            color: 'rgba(255,255,255,0.85)', fontSize: '13px', letterSpacing: '0.5px',
            background: 'rgba(0,0,0,0.45)', padding: '8px 16px', borderRadius: '20px',
            whiteSpace: 'nowrap', zIndex: 10000, pointerEvents: 'none',
          }}>
            Pinch or scroll to zoom · Drag to move · × to close
          </div>
        </div>
      )}

    </div>
  );
}